// extracted by mini-css-extract-plugin
export default {"popover":"OverlayPopover_popover__wG3hj","popoverBody":"OverlayPopover_popoverBody__-ge8r"};